
import posthog from 'posthog-js';

export const initPostHog = () => {
  const posthogPublicKey = import.meta.env.VITE_POSTHOG_PUBLIC_KEY || import.meta.env.NEXT_PUBLIC_POSTHOG_KEY;
  const posthogHost = import.meta.env.VITE_POSTHOG_HOST || import.meta.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://app.posthog.com';
  
  if (!posthogPublicKey) {
    console.warn('PostHog public key is not set. Analytics will not be tracked.');
    return;
  }
  
  console.log('Initializing PostHog with:', { 
    publicKey: posthogPublicKey?.substring(0, 5) + '...',
    host: posthogHost
  });
  
  // Initialize PostHog
  posthog.init(posthogPublicKey, {
    api_host: posthogHost,
    capture_pageview: true, // Automatically capture pageviews
    autocapture: true, // Automatically capture clicks, form submissions etc.
    capture_pageleave: true, // Capture when a user leaves the page
    session_recording: {
      maskAllInputs: false, // Only mask sensitive inputs (passwords, etc)
      maskTextSelector: '[data-ph-mask]', // Custom masking selector
    },
    // Respect Do Not Track setting in user's browser
    respect_dnt: true,
    // In development mode, we can enable debug mode
    debug: import.meta.env.DEV,
    // Disable persistent storage by default in development
    persistence: import.meta.env.DEV ? 'memory' : 'localStorage',
  });

  // Add sentry integration if available
  if (typeof window !== 'undefined' && 'Sentry' in window) {
    posthog.sentryIntegration();
  }
  
  return posthog;
};

export const setUserIdentity = (userId: string, userProperties?: Record<string, any>) => {
  try {
    if (userId) {
      posthog.identify(userId, userProperties);
      console.log('PostHog user identified:', userId);
    }
  } catch (error) {
    console.error('Error identifying user with PostHog:', error);
  }
};

export const resetUserIdentity = () => {
  try {
    posthog.reset();
    console.log('PostHog user identity reset');
  } catch (error) {
    console.error('Error resetting PostHog identity:', error);
  }
};

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  try {
    posthog.capture(eventName, properties);
  } catch (error) {
    console.error(`Error tracking event "${eventName}":`, error);
  }
};

export default posthog;
